var _defs, _g, _line, _line2, _rect, _polygon, _path, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreat6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.13 63.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#636255;}.cls-2{fill:none;stroke:#636154;stroke-miterlimit:10;}.cls-3{fill:#fff;}.cls-4{fill:#636154;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Treat6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_plastic_surgery_1050581",
    "data-name": "noun plastic surgery 1050581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-1",
    d: "M1.3,62.64Z",
    transform: "translate(-0.17 0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    className: "cls-1",
    d: "M.8,62.64H2.5c0-4.9-.1-10.4,1.9-15.3,3.4.8,7.5,2,10.8,5,2,1.8,4,3.7,5.9,5.6.6.6,1.1,1.1,1.7,1.6.8.8,1.4,1.2,2,1.2a3.41,3.41,0,0,0,2-.9c.2-.1.3-.3.5-.4,1.3-1.2,2.5-2.4,3.8-3.6l1.6-1.6a22.36,22.36,0,0,1,12-6.3.58.58,0,0,0,.4-.1c1.8,4.7,1.7,10,1.7,14.7a1.3,1.3,0,0,0,1.2,1.3,1.4,1.4,0,0,0,1.3-1.3c0-5.4.1-11.5-2.4-17a31.13,31.13,0,0,0-2.2-4c-.1-.2-.2-.3-.3-.5-1.3-2.2-2.6-4.3-3-6.4-.5-2.8.5-5.8,1.6-9a39.77,39.77,0,0,0,1.9-7.2c.1-.1.1-.2.2-.3,1.6-3.1,2-7.8-.7-11.2a11.6,11.6,0,0,1,1.5-5.1,1.35,1.35,0,0,0-.4-1.7,1.35,1.35,0,0,0-1.7.4,12.07,12.07,0,0,0-2.2,6.4v1l.3.4c2.3,2.5,2,6.2.7,8.7a.7.7,0,0,0-.2.4l-.1.2v.3a31.58,31.58,0,0,1-1.8,6.9c-1.2,3.5-2.2,6.8-1.7,10.2a18.18,18.18,0,0,0,2.7,6.3c-2.8.4-5.6.9-8.4,1.1a85.44,85.44,0,0,1-11.2-.1c-3.5-.3-7-.8-10.4-1.2-1.1-.2-2.2-.3-3.3-.4a16.33,16.33,0,0,0,2.2-5.5,17.63,17.63,0,0,0-.87-7.79L9.36,27c-.07-.22-.2-.59-.36-1.06,0,0-.17-.48-.3-.87-.66-1.93-.88-2.93-1.2-4a4.86,4.86,0,0,1-.2-1.2,6.55,6.55,0,0,0-.8-2.7c-1.3-2.5-1.6-6.2.7-8.7l.4-.5v-1A14,14,0,0,0,5.7.64,1.17,1.17,0,0,0,4.11.17L4,.24a1.17,1.17,0,0,0-.47,1.59l.07.11A11.22,11.22,0,0,1,5.1,7c-2.8,3.3-2.4,8.1-.7,11.2a5.18,5.18,0,0,1,.5,2c.1.5.2.9.3,1.4a33.07,33.07,0,0,0,1.3,4.1l.26.76.22.67.16.49a18.41,18.41,0,0,1,1,7.08c-.13,1.15-.77,3.14-3,6.5a32.42,32.42,0,0,0-2.5,4.5C.1,51.24.1,57.34.2,62.74Zm10.3-19.2c3.5.5,7,1,10.6,1.3,2.5.2,4.8.3,7,.3,1.6,0,3.1-.1,4.5-.2,3.2-.2,6.5-.8,9.6-1.3h0c.4.6.7,1.3,1.1,1.9a23.77,23.77,0,0,0-13,6.9l-1.6,1.6c-1.3,1.2-2.5,2.4-3.8,3.6l-.2.2a1.31,1.31,0,0,1-.4.3c-.1-.1-.3-.2-.4-.3-.6-.5-1.1-1.1-1.7-1.6-1.9-1.9-3.9-3.9-6-5.7A25,25,0,0,0,5.5,45l1.2-2.1c.4.1.7.1,1.1.2C9,43.14,10,43.34,11.1,43.44Zm-3-14.58",
    transform: "translate(-0.17 0.01)"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.63,
    y1: 32.25,
    x2: 1.9,
    y2: 35.49
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.99,
    y1: 33.33,
    x2: 2.57,
    y2: 37.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.7,
    y: 27.95,
    width: 15.02,
    height: 5.05,
    transform: "translate(-10.85 7.88) rotate(-22.77)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "6.38 31.02 20.04 25.29 21.7 29.93 8.04 35.66 6.38 31.02"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.91,26l1.33,3.7L8.5,35l-1.32-3.7L19.91,26m.59-1.33L5.91,30.74l2,5.58L22.5,30.2l-2-5.58Z",
    transform: "translate(-0.17 0.01)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.88,
    y1: 25.84,
    x2: 20.76,
    y2: 27.57
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreat6);
export default __webpack_public_path__ + "static/media/Treat6.88bf337338d44aee2b478705a7dc4e34.svg";
export { ForwardRef as ReactComponent };